// Shares one /api/getData request between the dashboard chrome (sidebar, topbar)
// across page navigations, refreshing after a short time so balances stay current.
const TTL_MS = 30 * 1000

let cache = { token: null, fetchedAt: 0, promise: null }

export const fetchDashboardUser = (route) => {
  const token = localStorage.getItem('token')
  if (!token) return Promise.resolve(null)

  const fresh = cache.token === token && cache.promise && Date.now() - cache.fetchedAt < TTL_MS
  if (fresh) return cache.promise

  const promise = fetch(`${route}/api/getData`, {
    headers: { 'x-access-token': token, 'Content-Type': 'application/json' },
  })
    .then(response => response.json())
    .then(data => (data.status === 'error' ? null : data))
    .catch(() => {
      cache.promise = null
      return null
    })

  cache = { token, fetchedAt: Date.now(), promise }
  return promise
}

export const clearDashboardUser = () => {
  cache = { token: null, fetchedAt: 0, promise: null }
}
